<template>
    <g>
      <wind-speed-volume1 />
      <wind-speed-volume2 />
      <wind-speed-volume3 />
      <wind-speed-volume4 />
      <wind-speed-volume5 />
      <wind-speed-volume6 />
      <wind-speed-volume7 />
      <wind-speed-volume8 />
      <wind-speed-volume9 />
      <wind-speed-volume10 />
      <wind-speed-volume11 />
    </g>
  </template>
  
<script>
import windSpeedVolume1 from './wind_speed/volume1.vue';
import windSpeedVolume2 from './wind_speed/volume2.vue';
import windSpeedVolume3 from './wind_speed/volume3.vue';
import windSpeedVolume4 from './wind_speed/volume4.vue';
import windSpeedVolume5 from './wind_speed/volume5.vue';
import windSpeedVolume6 from './wind_speed/volume6.vue';
import windSpeedVolume7 from './wind_speed/volume7.vue';
import windSpeedVolume8 from './wind_speed/volume8.vue';
import windSpeedVolume9 from './wind_speed/volume9.vue';
import windSpeedVolume10 from './wind_speed/volume10.vue';
import windSpeedVolume11 from './wind_speed/volume11.vue';
  
export default {
  components: {
    windSpeedVolume1,
    windSpeedVolume2,
    windSpeedVolume3,
    windSpeedVolume4,
    windSpeedVolume5,
    windSpeedVolume6,
    windSpeedVolume7,
    windSpeedVolume8,
    windSpeedVolume9,
    windSpeedVolume10,
    windSpeedVolume11,
  },
};
</script>



// WEBPACK FOOTER //
// wind_speed.vue?437d00f7